import React, { useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave } from '@fortawesome/free-solid-svg-icons';

//Context
import { useAuth } from '../../../../../context/auth';

//Helpers
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../../helpers/message';

//Components
import TextField from '../../../../../components/TextField';

//Api
import formulario_api from '../../../../../api/formulario_api';

export default function Identificacao({ formulario, setFormulario, loadFormulario, editavel = false }) {
    const { setLoading } = useAuth();

    //Estado de controle dos erros nos campos
    const [errors, setErrors] = useState({});

    //Função de onChange dos campos
    const onChange = (e) => {
        const { name, value } = e.target;
        setFormulario({
            ...formulario,
            [name]: value
        })
    }
    //Campos obrigatorios
    const camposIdentificacao = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "finalidade", required: true })
    ]

    //Função que salva o formulario
    const salvarFormulario = () => {
        const _errors = validarCampos(formulario, camposIdentificacao);
        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return true;

        const _formulario = { ...formulario };

        if (formulario.id) {
            setLoading(true);
            formulario_api.putFormulario(_formulario).then(response => {
                showMessage("Sucesso", "Operação realizada com sucesso", "success", () => loadFormulario(_formulario.id));
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(f => setLoading(false));
        } else {
            setLoading(true);
            formulario_api.postFormulario(_formulario).then(response => {
                showMessage("Sucesso", "Operação realizada com sucesso", "success", () => loadFormulario(response.data));
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
        }
    }

    return (
        <Row>
            <h5 className='mb-3'>Identificação do Formulário</h5>
            <Col md="12" lg="7">
                <TextField
                    name={"identificacao"}
                    label={"* Identificação"}
                    value={formulario.identificacao}
                    invalid={!!errors.identificacao}
                    onChange={onChange}
                    maxLength={100}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="3">
                <TextField
                    type={"select"}
                    name={"finalidade"}
                    label={"* Finalidade"}
                    options={[
                        {value: "Fiscalização", label: "Fiscalização"},
                        {value: "Análise", label: "Análise"}
                    ]}
                    value={formulario.finalidade}
                    invalid={!!errors.finalidade}
                    onChange={onChange} 
                    maxLength={100}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="2">
                <TextField
                    type={"select"}
                    label="* Status"
                    name={"status"}
                    options={
                        [
                            { label: "Ativo", value: "Ativo" },
                            { value: "Inativo", label: "Inativo" }
                        ]
                    }
                    onChange={onChange}
                    value={formulario.status}
                    invalid={!!errors.status}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center ${editavel ? "" : "d-none"}`}>
                <Button
                    color={formulario.id ? 'warning text-white' : 'success'}
                    className='px-4'
                    onClick={salvarFormulario}
                >
                    {formulario.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
                </Button>
            </Col>
        </Row>
    )
}